import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-2" }
const _hoisted_2 = { class: "grid gap-1" }

import { ref } from 'vue'
  import {cn, toast} from '@/utils/utils'
  import { Input } from "@/components/ui/input";
  import { Button } from "@/components/ui/button";
  import SigninService from "@/services/signin/signin.service";
  import {toTypedSchema} from "@vee-validate/zod";
  import * as z from "zod";
  import {useForm} from "vee-validate";
  import {FormControl, FormField, FormItem, FormMessage} from "@/components/ui/form";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordForm',
  setup(__props) {

  const isLoading = ref(false)
  const formSchema = toTypedSchema(z.object({
    email: z.string().email(),
  }))
  const { handleSubmit } = useForm({
    validationSchema: formSchema,
  })

  const onSubmit = handleSubmit(async (values) => {
    const res = await SigninService.forgotPassword(values.email);
    if (res?.data.statusCode === 200) {
      isLoading.value = false;
      toast.success(res.data.message, { timeout: 20000 });
    } else {
      toast.error(res?.data.message);
    }
    isLoading.value = false;

    setTimeout(() => {
      isLoading.value = false
    }, 3000)
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(cn)('grid gap-6'))
  }, [
    _createElementVNode("form", {
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(FormField), { name: "email" }, {
            default: _withCtx(({ componentField }) => [
              _createVNode(_unref(FormItem), { class: "w-full" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormControl), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Input), _mergeProps({
                        type: "email",
                        placeholder: _ctx.$t('column.email')
                      }, componentField, {
                        "auto-correct": "off",
                        "auto-capitalize": "none",
                        "auto-complete": "email",
                        disabled: isLoading.value
                      }), null, 16, ["placeholder", "disabled"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(FormMessage))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _createVNode(_unref(Button), { disabled: isLoading.value }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('login.forgot_password')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 32)
  ], 2))
}
}

})